var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{attrs:{"fill":"#363d44"}},[_c('path',{attrs:{"fill":"#363d44","d":"M21,8L2,2l5,20l4-7l7,7c0.828,0.828,2.172,0.828,3,0c0.824-0.824,0.831-2.169,0-3l-7-7L21,8z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }